import { cn } from "@/lib/utils";

const Button = ({ disabled, className, children, ...rest }) => {
  return (
    <button
      type="button"
      disabled={disabled}
      className={cn(
        disabled
          ? "px-6 py-3 rounded-xl text-white dark:text-primary-800 text-base font-semibold leading-normal bg-neutral-300 dark:bg-neutral-500"
          : "px-6 py-3 rounded-xl text-white dark:text-primary-800 text-base font-semibold leading-normal bg-primary-800 dark:bg-primary-300",
        className
      )}
      {...rest}
    >
      <span className="text-center text-white dark:text-primary-800 mobile-h3-small-semi-bold">
        {children}
      </span>
    </button>
  );
};

export default Button;
